import script from "./AdminVerificationConfirmModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminVerificationConfirmModal.vue?vue&type=script&setup=true&lang=ts"

import "./AdminVerificationConfirmModal.vue?vue&type=style&index=0&id=7ec3ccc6&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec3ccc6"]])

export default __exports__